import {
	QSR_SET,
	QSR_RESET_MESSAGE,
	QSR_REMOVE_NOTIFICATION,
	QSR_CREATE_REQUEST,
	QSR_CREATE_FAILURE,
	QSR_CREATE_SUCCESS,
	QSR_UPDATE_REQUEST,
	QSR_UPDATE_FAILURE,
	QSR_UPDATE_SUCCESS,
	QSR_CLONE_REQUEST,
	QSR_CLONE_FAILURE,
	QSR_CLONE_SUCCESS,
	QSR_FETCH_REQUEST,
	QSR_FETCH_FAILURE,
	QSR_FETCH_SUCCESS,
	QSRS_FETCH_REQUEST,
	QSRS_FETCH_FAILURE,
	QSRS_FETCH_SUCCESS,
} from '../constants/actionTypes';

const initialMessages = {
	message: {
		type: '',
		text: '',
	},
	messages: {
		type: '',
		list: [],
	},
	notifications: [],
};

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	isCloning: false,
	selected: false,
	entitiesByUser: [],
	...initialMessages,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case QSR_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case QSR_RESET_MESSAGE:
			return {
				...state,
				...initialMessages,
			};

		case QSR_REMOVE_NOTIFICATION:
			return {
				...state,
				notifications: state.notifications.filter(_ => _.id !== payload.id),
			};

		case QSR_CREATE_REQUEST:
			return {
				...state,
				...initialMessages,
				isCreating: true,
			};

		case QSR_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				messages: initialMessages.messages,
				notifications: [...state.notifications, payload.notification],
			};

		case QSR_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
				messages: initialMessages.messages,
			};

		case QSR_UPDATE_REQUEST:
			return {
				...state,
				...initialMessages,
				isUpdating: true,
			};

		case QSR_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				messages: {
					type: 'error',
					list: payload.messages,
				},
				notifications: [...state.notifications, payload.notification],
			};

		case QSR_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
				messages: initialMessages.messages,
			};

		case QSR_CLONE_REQUEST:
			return {
				...state,
				...initialMessages,
				isCloning: true,
			};

		case QSR_CLONE_FAILURE:
			return {
				...state,
				isCloning: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				messages: initialMessages.messages,
			};

		case QSR_CLONE_SUCCESS:
			return {
				...state,
				isCloning: false,
				message: {
					type: 'success',
					text: payload.message,
				},
				messages: initialMessages.messages,
			};

		case QSR_FETCH_REQUEST:
			return {
				...state,
				...initialMessages,
				isFetching: true,
				selected: false,
			};

		case QSR_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				selected: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				messages: initialMessages.messages,
			};

		case QSR_FETCH_SUCCESS:
			return {
				...state,
				...initialMessages,
				isFetching: false,
				selected: Number(payload.id),
			};

		case QSRS_FETCH_REQUEST:
			return {
				...state,
				...initialMessages,
				isFetching: true,
			};

		case QSRS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				messages: initialMessages.messages,
			};

		case QSRS_FETCH_SUCCESS:
			return {
				...state,
				...initialMessages,
				isFetching: payload.keepFetching || false,
				entitiesByUser: payload.byUserIds
					? [...state.entitiesByUser, ...payload.byUserIds]
					: state.entitiesByUser,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/QSR.js